import { IAvailableQuestions, IButtonState, IQuestionResponse, IQuestionType } from "../CommonProps";
const ArrowRightSvg = require("../assets/images/svg/arrow-right.svg").default;

export interface IQuestionCardProps {
  question: IAvailableQuestions;
  handleQuestionResponse: (obj: IQuestionResponse) => void;
}
const QuestionCard = ({ question, handleQuestionResponse }: IQuestionCardProps) => {
  question.state = question.step === 3 ? (question.state = 3) : question.state;

  const handleAction = (action: string) => {
    const isYesAction = action === "YES";
    const actionState = isYesAction ? IButtonState.YES : IButtonState.NO;
    let key = "value";
    let value = "";
  
    if (question.type === IQuestionType.FAULT) {
      key = "claimLiability";
      value = isYesAction ? "AtFault" : "NotAtFault";
    } else if (question.type === IQuestionType.FAULT_DETAILS && isYesAction) {
      value = "At Fault details obtained";
    } else if (question.type === IQuestionType.FAULT_INSURANCE && isYesAction) {
      value = "At Fault has insurance";
    }
  
    handleQuestionResponse({ key, value, type: question.type, actionState, state: question.state });
  };
  
  return (
    <div className={`question-crd-main ${question.state == 1 ? `question-crd-active` : question.state == 3 ? "question-crd-final" : ""} `}>
      {question.state == 1 && <img src={ArrowRightSvg} className="arrow-right" alt="arrow-right" />}
      <p className="question-crd-title">{question.title}</p>
      <div className="btn-container">
        <button
          onClick={() => handleAction("NO")}
          className={`${question.actionState === IButtonState.NONE || question.actionState === IButtonState.YES ? "btn-action" : "button-dark"}`}
        >
          No
        </button>
        <button
          onClick={() => handleAction("YES")}
          className={`${question.actionState === IButtonState.NONE || question.actionState === IButtonState.NO ? "btn-action" : "button-dark"}`}
        >
          Yes
        </button>
      </div>
    </div>
  );
};

export default QuestionCard;
